import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Image } from 'react-bootstrap';
import axios from 'axios';
// import uploadImage from '../../Services/azure-storage-blob.js';
import { ServerPath } from '../../Constant/index.jsx';
import { _axios } from '../../utils/axios';
import ImageUpload from './ImageUpload';
import cookieUtils from '../../utils/cookieUtils';
import {uploadImage} from '../../Services/r2-storage-blob.js';

const EditTrip = (props) => {
    const [show, setShow] = useState(false);
    const [tripId, setTripId] = useState(props?.data?.journey_id);
    const [tripName, setTripName] = useState('');
    const [email, setEmail] = useState('');
    const [contactNumber, setContactNumber] = useState('');
    const [contactName, setContactName] = useState('');
    const [thumbnail, setThumbnail] = useState('');
    const [wallpaperImages, setWallpaperImages] = useState([]);
    const [parikramaImages, setParikramaImages] = useState([]);
    const [location, setLocation] = useState('');
    const [tripLength, setTripLength] = useState('');
    const [routeType, setRouteType] = useState('');
    const [tripPath, setTripPath] = useState('');
    const [description, setDescription] = useState('');
    const [elevationGain, setElevationGain] = useState('');
    const [status, setStatus] = useState(props?.data?.status);
    const [uploading, setUploading] = useState(false);
    const [imageUrl, setImageUrl] = useState('');

    useEffect(() => {
    // Debug: Check all possible auth data
    console.log('Auth Debug:', {
        token: cookieUtils.getSecureCookie('token'),
        jwt: cookieUtils.getSecureCookie('jwt'),  
        accessToken: cookieUtils.getSecureCookie('accessToken'),
        role: cookieUtils.getSecureCookie('role'),
        email: cookieUtils.getSecureCookie('email'),
        adminId: cookieUtils.getSecureCookie('admin_id'),
        userId: cookieUtils.getSecureCookie('user_id')
    });
}, []);

    useEffect(() => {
        if (props.data) {
            setTripName(props.data.trip_name || '');
            setEmail(props.data.email || '');
            setContactNumber(props.data.contact_number || '');
            setContactName(props.data.contact_name || '');
            setThumbnail(props.data.thumbnail);
            setLocation(props.data.location || '');
            setTripLength(props.data.trip_length || '');
            setRouteType(props.data.route_type || '');
            setTripPath(props.data.trip_path || '');
            setDescription(props.data.description || '');
            setElevationGain(props.data.elevation_gain || '');

            // Parse existing image URLs
            if (props.data.wallpapers) {
                const wallpaperUrls = props.data.wallpapers.split(',').filter(url => url.trim());
                const wallpaperImageObjects = wallpaperUrls.map((url, index) => ({
                    id: `existing-wallpaper-${index}`,
                    url: url.trim(),
                    uploading: false,
                    error: null,
                    file: null
                }));
                setWallpaperImages(wallpaperImageObjects);
            }

            if (props.data.parikrama_in_action) {
                const parikramaUrls = props.data.parikrama_in_action.split(',').filter(url => url.trim());
                const parikramaImageObjects = parikramaUrls.map((url, index) => ({
                    id: `existing-parikrama-${index}`,
                    url: url.trim(),
                    uploading: false,
                    error: null,
                    file: null
                }));
                setParikramaImages(parikramaImageObjects);
            }
        }
        console.log(props?.data);
    }, [props.data]);

    const handleClose = () => setShow(false);
    
    const handleShow = (event) => {
        event.preventDefault();
        setShow(true);
    };

    const handleFileChange = (e) => {
        setThumbnail(e.target.files[0]);
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        // Validate image uploads
        const failedUploads = [...wallpaperImages, ...parikramaImages]
            .filter(img => img.error || img.uploading);
        
        if (failedUploads.length > 0) {
            alert('Please resolve failed uploads before submitting');
            return;
        }

        setUploading(true);
        
        try {
            let uploadedUrl = thumbnail;
            if (typeof thumbnail !== 'string') {
                uploadedUrl = await uploadImage(thumbnail, thumbnail.name, 'parikrama-qa', 'images');
                setImageUrl(uploadedUrl);
            }

            // Extract successfully uploaded URLs
            const wallpaperUrls = wallpaperImages
                .filter(img => img.url)
                .map(img => img.url)
                .join(',');
            
            const parikramaUrls = parikramaImages
                .filter(img => img.url)
                .map(img => img.url)
                .join(',');

            const response = await axios.patch(`${ServerPath}/tripdetails`, {
                journey_id: tripId,
                trip_name: tripName,
                email,
                contact_number: contactNumber,
                contact_name: contactName,
                thumbnail: uploadedUrl,
                wallpapers: wallpaperUrls,
                parikrama_in_action: parikramaUrls,
                location,
                trip_length: tripLength,
                route_type: routeType,
                trip_path: tripPath,
                description,
                elevation_gain: elevationGain,
                status: status,
            });
            
            console.log(response.data);
            handleClose();
            // window.location.reload();
        } catch (error) {
            console.error(error);
            alert('Form submission failed. Please try again.');
        } finally {
            setUploading(false);
        }
    };

    return (
        <>
            <Button onClick={handleShow} className="btn-square btn btn-primary mx-2">
                <i className='icon-pencil-alt'></i>
            </Button>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Edit Trip</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                    <Form onSubmit={handleSubmit} className="needs-validation" noValidate>
                        <Row className="g-3">
                            <Col md={6}>
                                <Form.Group controlId="validationCustom01">
                                    <Form.Label>Trip Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={tripName}
                                        onChange={(e) => setTripName(e.target.value)}
                                        placeholder="Enter Trip Name"
                                        required
                                    />
                                </Form.Group>
                                <Form.Group controlId="validationCustom02">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="Enter Email"
                                        required
                                    />
                                </Form.Group>
                                <Form.Group controlId="validationCustom03">
                                    <Form.Label>Contact Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={contactName}
                                        onChange={(e) => setContactName(e.target.value)}
                                        placeholder="Enter Contact Name"
                                        required
                                    />
                                </Form.Group>
                                <Form.Group controlId="validationCustom04">
                                    <Form.Label>Contact Number</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={contactNumber}
                                        onChange={(e) => setContactNumber(e.target.value)}
                                        placeholder="Enter Contact Number"
                                        required
                                    />
                                </Form.Group>
                                <Form.Group controlId="validationCustom06">
                                    <Form.Label>Length</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={tripLength}
                                        onChange={(e) => setTripLength(e.target.value)}
                                        placeholder="Enter Length"
                                        required
                                    />
                                </Form.Group>
                                <Form.Group controlId='formGridStatus'>
                                    <Form.Label>Status</Form.Label>
                                    <Form.Control
                                        as="select"
                                        value={status}
                                        onChange={(e) => setStatus(e.target.value)}
                                    >
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group controlId="validationCustom05">
                                    <Form.Label>Location</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={location}
                                        onChange={(e) => setLocation(e.target.value)}
                                        placeholder="Enter Location"
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="exampleFormControlTextarea4">
                                    <Form.Label>Current Thumbnail Image</Form.Label>
                                    {thumbnail && typeof thumbnail === 'string' && (
                                        <div className="mb-2">
                                            <Image src={thumbnail} alt="Current Thumbnail" thumbnail style={{ maxWidth: '200px', maxHeight: '150px' }} />
                                        </div>
                                    )}
                                    <Form.Label>Upload New Thumbnail Image</Form.Label>
                                    <Form.Control
                                        type="file"
                                        onChange={handleFileChange}
                                        accept="image/*"
                                    />
                                </Form.Group>
                                <Form.Group controlId="validationCustom07">
                                    <Form.Label>Route Type</Form.Label>
                                    <Form.Control
                                        as="select"
                                        value={routeType}
                                        onChange={(e) => setRouteType(e.target.value)}
                                        required
                                    >
                                        <option value="" disabled>Choose...</option>
                                        <option value="Loop">Loop</option>
                                        <option value="Out & Back">Out & Back</option>
                                        <option value="Point to Point">Point to Point</option>
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group controlId="validationCustom08">
                                    <Form.Label>Elevation Gain</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={elevationGain}
                                        onChange={(e) => setElevationGain(e.target.value)}
                                        placeholder="Enter Elevation Gain"
                                    />
                                </Form.Group>
                            </Col>

                            {/* Image Upload Sections - Side by Side */}
                            <Col md={12}><hr /></Col>
                            <Col md={6}>
                                <ImageUpload
                                    label="Wallpapers"
                                    images={wallpaperImages}
                                    setImages={setWallpaperImages}
                                    maxImages={10}
                                />
                            </Col>

                            <Col md={6}>
                                <ImageUpload
                                    label="Parikrama in Action"
                                    images={parikramaImages}
                                    setImages={setParikramaImages}
                                    maxImages={10}
                                />
                            </Col>
                            <Col md={12}><hr /></Col>

                            <Col md={12}>
                                <Form.Group controlId="exampleFormControlTextarea4">
                                    <Form.Label>Path</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={tripPath}
                                        onChange={(e) => setTripPath(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={12}>
                                <Form.Group controlId="exampleFormControlTextarea5">
                                    <Form.Label>Description</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button form='EditTripForm' variant="primary" type='submit' onClick={handleSubmit}>
                        {uploading ? 'Uploading...' : 'Update'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default EditTrip;